
export class mailModel {
    public name!: string;
    public phone!: string;
    public email!: string;
    public subject!: string;
    public message!: string;
    public captcha!: string;
}